import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * Product Routes and Pages
 */
const ListProductPage = React.lazy(() => import("./ListProductPage"));
const AddProductPage = React.lazy(() => import("./AddProductPage.js"));
const EditProductPage = React.lazy(() => import("./EditProductPage"));

const ProductRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListProductPage />} />
      <Route exact path="/add" element={<AddProductPage />} />
      <Route exact path="/edit/:id" element={<EditProductPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default ProductRoutes;
